namespace Matrix.Data {
    export class EntityLinkColumns {
        static columnsKey = 'Data.EntityLink';
    }
}
